export default __webpack_public_path__ + "static/media/product_batch_csv_samples.06db5846.zip";